import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, LockIcon, UsersIcon, ClockIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const deliverables = ['Manual completo de 20 páginas', 'Plantillas de mensajes listas para usar'];
export function OfferSection() {
  return <section id="offer" className="py-24 px-4 bg-[#0A0A0A] relative overflow-hidden" data-id="element-54">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-[600px] bg-[#1A7A4A]/5 rounded-full blur-[100px] pointer-events-none" data-id="element-55" />

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-56">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-[#0f0f0f] border-2 border-[#C9A84C]/30 rounded-3xl p-8 md:p-12 shadow-[0_0_50px_rgba(201,168,76,0.1)] text-center" data-id="element-57">
          <p className="text-lg md:text-xl text-[#D1D5DB] mb-6 max-w-lg mx-auto leading-relaxed" data-id="element-58">
            Si llegaste hasta aquí es porque sabes que necesitas cambiar algo.
            <br data-id="element-59" />
            <span className="text-[#C9A84C] font-bold" data-id="element-60">
              La única pregunta ahora es si vas a seguir igual… o empezar hoy.
            </span>
          </p>

          <h2 id="payment" className="text-3xl md:text-4xl font-extrabold italic text-white mb-8" data-id="element-61">
            Tu Inversión Hoy
          </h2>

          <div className="mb-8 flex flex-col items-center justify-center" data-id="element-62">
            <p className="text-sm text-neutral-400 mb-1 uppercase tracking-wider" data-id="element-63">
              Valor real
            </p>
            <span className="text-3xl text-neutral-500 line-through decoration-red-500/70 decoration-3 mb-3" data-id="element-64">
              $23 USD
            </span>
            <div className="inline-flex items-center gap-2 bg-red-500/20 border border-red-500/40 text-red-400 font-extrabold text-sm md:text-base px-4 py-1.5 rounded-full mb-3 animate-pulse" data-id="element-65">
              🔥 70% DESCUENTO — SOLO POR HOY
            </div>
            <div className="flex items-center gap-2 text-sm text-[#D1D5DB]/70 mb-4" data-id="element-66">
              <UsersIcon className="w-4 h-4 text-[#1A7A4A]" data-id="element-67" />
              <span data-id="element-68">
                <strong className="text-white" data-id="element-69">1,842 personas</strong> ya
                descargaron el manual
              </span>
            </div>
            <div className="flex items-baseline justify-center text-[#C9A84C] drop-shadow-[0_0_15px_rgba(201,168,76,0.5)]" data-id="element-70">
              <span className="text-4xl font-bold" data-id="element-71">$</span>
              <span className="text-8xl font-black tracking-tighter" data-id="element-72">7</span>
              <span className="text-2xl font-bold ml-2" data-id="element-73">USD</span>
            </div>
          </div>

          <div className="flex flex-col items-center mb-10" data-id="element-74">
            <CTAButton text="QUIERO DESCARGARLO AHORA" href="https://pay.hotmart.com/M104839164S" className="w-full md:w-auto text-lg md:text-2xl py-5 px-10" data-id="element-75" />
            <p className="mt-4 text-neutral-500 text-sm" data-id="element-76">
              Descarga inmediata. Acceso de por vida.
            </p>
            <div className="mt-4 inline-flex items-center gap-2 bg-red-500/10 border border-red-500/30 text-red-400 text-sm font-bold px-4 py-2 rounded-lg" data-id="element-77">
              <ClockIcon className="w-4 h-4" data-id="element-78" />
              <span data-id="element-79">⚠️ Precio sube a $19 USD en 24 horas</span>
            </div>
          </div>

          <p className="text-sm text-[#D1D5DB]/60 italic mb-6 max-w-md mx-auto" data-id="element-80">
            "Este sistema está basado en los métodos que miles de freelancers
            usan para cobrar en dólares desde Latinoamérica."
          </p>

          <p className="text-xl text-[#D1D5DB] font-medium mb-10 max-w-lg mx-auto" data-id="element-81">
            Menos que una cena.{' '}
            <span className="text-[#1A7A4A] font-bold" data-id="element-82">
              Más que un sueldo mínimo completo transformado.
            </span>
          </p>

          <div className="bg-[#0A0A0A] rounded-2xl p-6 mb-10 text-left max-w-md mx-auto border border-neutral-800" data-id="element-83">
            <h3 className="text-white font-bold mb-4 text-center" data-id="element-84">
              Lo que te llevas ahora mismo:
            </h3>
            <ul className="space-y-3" data-id="element-85">
              {deliverables.map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-86">
                  <CheckIcon className="w-5 h-5 text-[#1A7A4A] flex-shrink-0 mt-0.5" data-id="element-87" />
                  <span className="text-[#D1D5DB]" data-id="element-88">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="mb-10 flex items-center justify-center gap-3 text-[#D1D5DB]/70 bg-[#0A0A0A]/50 py-3 px-6 rounded-full border border-neutral-800 w-fit mx-auto" data-id="element-89">
            <LockIcon className="w-5 h-5 text-[#C9A84C]" data-id="element-90" />
            <span className="text-sm md:text-base" data-id="element-91">
              <strong className="text-white" data-id="element-92">Garantía de satisfacción:</strong>{' '}
              Si no te funciona, te devolvemos tu dinero.
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}